export { default as HugeIcons } from './HugeIcons';
export type { HugeIconSize } from './HugeIcons';
export { HugeIcon } from './HugeIcon.consts';
